const CryptoJS = require('crypto-js');

// 字段排序
export const sortObjectAndStringify = (obj, secret = 'fee04c097305c62b201d0ecd72a568d7') => {
 const sortedKeys = Object.keys(obj).sort()

 return CryptoJS.MD5(secret + sortedKeys.map(item => `${obj[item]}`).join("") + secret).toString()
}

export const formatNumberWithThousandSeparator = (str: text) => {
 if (!str) {
  return str
 }
 let number = parseFloat(str);
 return (number+'').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function formatKMB(num, digits = 2) {
 const n = parseFloat(num);
 if (isNaN(n)) return '0';

 const lookup = [
  { value: 1, symbol: "" },
  { value: 1e3, symbol: "K" },
  { value: 1e6, symbol: "M" },
  { value: 1e9, symbol: "B" },
 ];

 // 找到对应的单位
 const item = lookup.slice().reverse().find(item => Math.abs(n) >= item.value);

 // 如果找不到（即数字小于1000），直接返回原数或格式化后的原数
 if (!item) return n.toString();
 console.log("(n / item.value)====>",(n / item.value))

 // 计算结果并处理精度
 const result = (n / item.value).toFixed(digits);

 // 使用 parseFloat 去掉末尾多余的 0（例如 1.20K 变为 1.2K）
 return parseFloat(result) + item.symbol;
}